// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1BUnH","alert":"SettungsInbox_alert__1c9HT"};